import React, {Component} from "react";
import './LoadingBar.scss';

export default ({show}) =>{
    if (!show) {
        return null
    }
    return <div className='loading-bar'/>
}
